import { useTranslation } from 'react-i18next';

import { PlanDisclaimerWrapperStyled } from './HospitalIndemnityDisclaimerStyled';

export const HospitalIndemnityDisclaimer = () => {
  const { t } = useTranslation('enrollment.hospitalIndemnityDisclaimer');

  return(
    <PlanDisclaimerWrapperStyled>
      <h2>{t('federalDisclosure')}</h2>
      <hr />
      <div className="pb-3">
        <b>{t('important')}</b>
      </div>
      <div className="pb-3">
        <p>{t('disclaimer.text')}</p>
        <ul>
          <li>{t('disclaimer.listText1')}</li>
          <li>{t('disclaimer.listText2')}</li>
          <li>{t('disclaimer.listText3')}</li>
          <li>{t('disclaimer.listText4')}</li>
        </ul>
      </div>
      <div className="pb-3">
        <b>{t('looking.text')}</b>
        <ul>
          <li dangerouslySetInnerHTML={{ __html: t('looking.listText1') }}></li>
          <li>{t('looking.listText2')}</li>
        </ul>
      </div>
      <div>
        <b>{t('questions.text')}</b>
        <ul>
          <li>{t('questions.listText1')}</li>
          <li>{t('questions.listText2')}</li>
        </ul>
      </div>
    </PlanDisclaimerWrapperStyled>
  );
};
